import React from 'react';
import './EyePowerSubmitInfo.scss';
import FooterBar from './FooterBar';
import './FooterBar.scss';

function EyePowerSubmitInfo(props) {
  const {
    continueEyePower,
    selectedLensPackage,
    productData,
    addonsTotal,
    currencyMark,
    redisCommonData,
  } = props;
  const framePrice =
    productData?.prices?.length === 3
      ? productData?.prices?.[2]?.price
      : productData?.prices?.[1]?.price;
  const homeEyeCheckAndManual = redisCommonData?.HOME_EYE_CHECKUP_AND_MANUALLY;
  let price = selectedLensPackage?.prices?.[1].price + framePrice;
  price += addonsTotal || 0;
  const {
    WHAT_ABOUT_MY_EYE_POWER,
    SUBMIT_EYE_POWER_TEXT,
    ENTER_MANUALLY,
    PHONE_ASSISTANCE,
    UPLOAD_PRESCRIPTION,
    HOME_EYE_CHECKUP,
    POWER_SUBMITTED_TIME,
    NO_ADDITIONAL_CHARGES,
    I_HAVE_READ_AND_UNDERSTOOD_THE_TERMS_OF_POWER_SUBMISSION,
    SUBMIT_EYE_POWER,
    SUBTOTAL,
    CURRENCY_CODE,
    I_AGREE,
  } = props.dataLocale || {};
  const currencySymbol = productData?.prices[0]
    ? currencyMark?.[productData?.prices?.[0]?.currencyCode]
    : currencyMark[CURRENCY_CODE];
  return (
    <React.Fragment>
      <div className="h-100vh-less240 overflow-y-scroll margin-t150 margin-b90">
        <div className="extra-div">
          <div className="submit-power-info padding-l15 padding-r15">
            <div
              className="margin-0-auto padding-15 border-gray bora-4"
              style={{ maxWidth: '602px' }}
            >
              <div className="text-center fs22 fw700 padding-b15">{WHAT_ABOUT_MY_EYE_POWER}</div>
              <div className="fs15 w-80 margin-0-auto">
                <img
                  alt={SUBMIT_EYE_POWER}
                  className="padding-r10"
                  src="https://static.lenskart.com/media/desktop/img/pdp/right.png"
                />
                {SUBMIT_EYE_POWER_TEXT}
              </div>
              <ul className="padding-t15 padding-b15 fs15 w-80 margin-0-auto">
                {homeEyeCheckAndManual && (
                  <li className="padding-b5">
                    <img
                      alt={ENTER_MANUALLY}
                      className="padding-r10"
                      src="https://static.lenskart.com/media/desktop/img/pdp/enter_manullay.png"
                    />
                    {ENTER_MANUALLY}
                  </li>
                )}
                <li className={homeEyeCheckAndManual ? 'padding-t5' : ''}>
                  <img
                    alt={PHONE_ASSISTANCE}
                    className="padding-r10"
                    src="https://static.lenskart.com/media/desktop/img/pdp/phone.png"
                  />
                  {PHONE_ASSISTANCE}
                </li>
                <li className="padding-b5">
                  <img
                    alt={UPLOAD_PRESCRIPTION}
                    className="padding-r10"
                    src="https://static.lenskart.com/media/desktop/img/pdp/upload_prescription.png"
                  />
                  {UPLOAD_PRESCRIPTION}
                </li>
                {homeEyeCheckAndManual && (
                  <li className="padding-t5">
                    <img
                      alt={HOME_EYE_CHECKUP}
                      className="padding-r10"
                      src="https://static.lenskart.com/media/desktop/img/pdp/home_eye_checkup.png"
                    />
                    {HOME_EYE_CHECKUP}
                  </li>
                )}
              </ul>
              <div className="border-top-gray padding-t15 padding-b15">
                <div className="w-80 margin-0-auto fs15">
                  <img
                    alt="power submit time"
                    className="padding-r10"
                    src="https://static.lenskart.com/media/desktop/img/pdp/right.png"
                  />
                  {POWER_SUBMITTED_TIME}
                </div>
                <div className="w-80 margin-0-auto fs15 padding-t10">
                  <img
                    alt="no additional charges"
                    className="padding-r10"
                    src="https://static.lenskart.com/media/desktop/img/pdp/right.png"
                  />
                  {NO_ADDITIONAL_CHARGES}
                </div>
              </div>
            </div>
            <div className="display-flex align-items-center justify-content-center margin-t15 margin-b25">
              <span className="tnc-headline">
                {I_HAVE_READ_AND_UNDERSTOOD_THE_TERMS_OF_POWER_SUBMISSION}
              </span>
            </div>
          </div>
        </div>
      </div>
      <FooterBar
        currencySymbol={currencySymbol}
        price={price}
        selectedIndex={props?.selectedIndex}
        subTotal={SUBTOTAL}
      >
        <button
          className="text-uppercase bora-4 continue-btn border-none fs16 padding-t10 padding-b10 text-color-white fw600 bg-topaz "
          onClick={continueEyePower}
        >
          {I_AGREE}
        </button>
      </FooterBar>
    </React.Fragment>
  );
}

export default EyePowerSubmitInfo;
